<div class="page">
	<app-page-header header="Forum">
	</app-page-header>

	<div class="category-container">
		<app-simple-table [columns]="columns" [data]="forums" [paginator]="true" [showFilter]="false"
			[showActions]="false">
		</app-simple-table>
	</div>
</div>